// extracted by mini-css-extract-plugin
export var deliveryRow = "_ov-a";
export var fixedHeight = "_ov-4";
export var freightLogo = "_ov-9";
export var fullWidth = "_ov-3";
export var priceColumn = "_ov-5";
export var radioSelected = "_ov-7";
export var radioUnselected = "_ov-6";
export var selectedOption = "_ov-2";
export var selectedOptionContainer = "_ov-1";
export var selection = "_ov-0";
export var tallSkeletonText = "_ov-8";